import FileUpload from './FileUpload.vue'
export default {
  install: function (Vue) {
    Vue.component('FileUpload', FileUpload)
  }
}